<template>
	<div class="login-pass-wrap">
		<div class="greet-text">
			<p>你好，</p>
			<p>欢迎来到鱼水缘</p>
		</div>
		<div class="edit-account">
			<ul>
				<li>
					<input type="tel" placeholder="手机号" v-model="tel"/>
				</li>
				<li>
					<input type="password" placeholder="输入登录密码" ref="passInput" v-model="pass" />
					<span class="icon" @click="passType=!passType">
						<img v-if="passType==0" src="../../assets/img/mine/sl_login_ic_ce.png" alt="" />
						<img v-else src="../../assets/img/mine/sl_login_ic_blink.png" alt="" />
					</span>
				</li>
			</ul>
			<p class="options">
				<span>忘记了？找回密码</span>
				<span @click="showCodeLogin">验证码登录</span>
			</p>
			<div class="login-btn">
				<button @click="submitLogin">登录</button>
			</div>
		</div>
		<div class="other-login" v-bind:hidden="true">
			<p class="title">
				<span class="line"></span>
				<span class="text">第三方登录</span>
				<span class="line"></span>
			</p>
			<ul class="login-btns">
				<li><img src="../../assets/img/mine/sl_sign_ic_wechat.png"/></li>
				<li><img src="../../assets/img/mine/sl_sign_ic_qq.png"/></li>
				<li><img src="../../assets/img/mine/sl_sign_ic_sina.png"/></li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		name:"login-pass",
		data(){
			return{
				tel:"",
				pass:"",
				passType: false,
			}
		},
		watch: {
			passType(newV, oldV) {
				if(newV == true) {
					this.$refs.passInput.type = "text"
				} else {
					this.$refs.passInput.type = "password"
				}
			}
		},
		methods:{
			submitLogin(){
				console.log(this.tel,this.pass);
				if(!(/^1[34578]\d{9}$/.test(this.tel))||this.pass=="") {
					this.$toast({
						message: "请检查手机号、密码是否正确填写",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.$axios({
						url:"User/login",
						method:"post",
						data:{
							phone:this.tel,
							password:this.$md5(this.pass),
							type:"phone",
							login_type:2,
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message: "登录成功",
								position: "bottom",
								duration: 3000
							});
							this.$store.commit("getUserId",res.data.data.uid);
							if(window.localStorage){
								localStorage.setItem("yushuiyuanid",res.data.data.uid);
							}else{
							    document.cookie = "yushuiyuanid="+res.data.data.uid;
							}
							this.$router.push({name:"mine"})
						}
					}).catch(err=>{
						console.log(err)
					})
				}
			},
			showCodeLogin(){
				this.$emit("showCodeLogin")
			}
		}
	}
</script>

<style scoped>
	.login-pass-wrap{
		padding: 3rem 1.5rem 0;
	}
	.greet-text{
		font-size: 1.5rem;
		color: #282828;
		line-height: 2.5rem;
		margin-bottom: 2rem;
	}
	.edit-account li{
		border-bottom: 1px solid #f3f3f3;
		position: relative;
	}
	.edit-account li input{
		width: 100%;
		height: 2.5rem;
		border: 0;
		background: none;
		outline: 0;
		padding: 0 0.5rem;
		font-size: 0.8rem;
	}
	.edit-account li .get-code {
		position: absolute;
		font-size: 0.7rem;
		background: rgba(255, 97, 97, .6);
		padding: 0.2rem 0.6rem;
		color: #fff;
		border-radius: 3px;
		right: 0;
		top: 0.5rem;
	}
	
	.edit-account li .icon {
		position: absolute;
		right: 0;
		top: 0.5rem;
	}
	
	.edit-account li .icon img {
		width: 1.5rem;
	}
	
	.edit-account li .get-code:active {
		opacity: 0.7;
	}
	.options{
		font-size: 0.6rem;
		color: #282828;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 2.4rem;
		padding: 0 0.5rem;
	}
	.options span:active{
		opacity: 0.7;
	}
	.login-btn{
		padding: 1rem 0.5rem;
	}
	.login-btn button{
		width: 100%;
		height: 2.5rem;
		color: #7b7b7b;
		font-size: 0.8rem;
		background: #eee;
		border: 0;
		outline: 0;
		border-radius: 5px;
	}
	.other-login{
		position: relative;
		width: 100%;
		bottom: 0.5rem;
		left: 0;
		margin-top: 6rem;
	}
	.other-login .title{
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 2rem;
	}
	.other-login .title .text{
		padding: 0 1rem;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.other-login .title .line{
		flex: 1;
		height: 1px;
		border-bottom: 1px solid #f3f3f3;
	}
	.other-login .login-btns{
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 0.5rem;
	}
	.other-login .login-btns li{
		padding: 0.5rem;
		margin: 0 0.5rem;
	}
	.other-login .login-btns li:active{
		background: #fafafa;
	}
	.other-login .login-btns img{
		width: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/LoginPass.vue